import React from "react"
import { Helmet } from "react-helmet"

export function PageHelmet({ children }: { children?: React.ReactNode }) {
  const isDev = process.env.NODE_ENV === "development"
  const devOrLive = isDev ? "DEV" : "Live"
  return (
    <Helmet>
      {children ? (
        <title>
          {children} - Fortus {devOrLive}
        </title>
      ) : (
        <title>Fortus {devOrLive}</title>
      )}
    </Helmet>
  )
}
